import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const StickersOnboardingPage = lazy(() => import('../components/StickersOnboardingPage'));

export function stickersOnboardingRoutes() {
	return (
		<Route path={FRONTEND_ROUTES.STICKERS_ONBOARDING} element={<StickersOnboardingPage />} />
	);
}
